import React, { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);

// App-wide accessibility preferences (persisted to localStorage). Toggles the
// `hc` (high-contrast) and `dys` (dyslexia-friendly font) classes on <html>.
export function AccessibilityProvider({ children }) {
  const [hc, setHc] = useState(() => localStorage.getItem("ns_a11y_hc") === "1");
  const [dys, setDys] = useState(() => localStorage.getItem("ns_a11y_dys") === "1");

  useEffect(() => {
    document.documentElement.classList.toggle("hc", hc);
    localStorage.setItem("ns_a11y_hc", hc ? "1" : "0");
  }, [hc]);

  useEffect(() => {
    document.documentElement.classList.toggle("dys", dys);
    localStorage.setItem("ns_a11y_dys", dys ? "1" : "0");
  }, [dys]);

  return <Ctx.Provider value={{ hc, setHc, dys, setDys }}>{children}</Ctx.Provider>;
}

export const useA11y = () => useContext(Ctx);
